module.exports = __webpack_public_path__ + "static/img/aepic-13.a605d83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-13.jpg
// module id = 7RHC
// module chunks = 51